// @generated by protoc-gen-es v1.2.0 with parameter "target=ts,import_extension=.ts"
// @generated from file protogen/advisor_pipeline_service.proto (package protogen, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { EntityMetadata } from "./common_pb.ts";

/**
 * @generated from message protogen.AdvisorApplication
 */
export class AdvisorApplication extends Message<AdvisorApplication> {
  /**
   * @generated from field: string ref = 1;
   */
  ref = "";

  /**
   * "new", "in-progress", "approved", "rejected"
   *
   * @generated from field: string status = 2;
   */
  status = "";

  /**
   * @generated from field: int64 submittedSec = 3;
   */
  submittedSec = protoInt64.zero;

  /**
   * @generated from field: int64 lastActivitySec = 4;
   */
  lastActivitySec = protoInt64.zero;

  /**
   * @generated from field: protogen.EntityMetadata metadata = 5;
   */
  metadata?: EntityMetadata;

  /**
   * @generated from field: string typeformId = 6;
   */
  typeformId = "";

  /**
   * @generated from field: string firstName = 7;
   */
  firstName = "";

  /**
   * @generated from field: string lastName = 8;
   */
  lastName = "";

  /**
   * @generated from field: string phoneNumber = 9;
   */
  phoneNumber = "";

  /**
   * @generated from field: string email = 10;
   */
  email = "";

  /**
   * @generated from field: int32 zipCode = 11;
   */
  zipCode = 0;

  /**
   * @generated from field: string citiesWithExpertise = 12;
   */
  citiesWithExpertise = "";

  /**
   * @generated from field: string linkedinProfile = 13;
   */
  linkedinProfile = "";

  /**
   * @generated from field: repeated string superpowers = 14;
   */
  superpowers: string[] = [];

  /**
   * @generated from field: string organizationStrategy = 15;
   */
  organizationStrategy = "";

  /**
   * @generated from field: bool hasFlexibility = 16;
   */
  hasFlexibility = false;

  /**
   * @generated from field: bool willingToRunErrands = 17;
   */
  willingToRunErrands = false;

  /**
   * @generated from field: repeated string errandSelections = 27;
   */
  errandSelections: string[] = [];

  /**
   * @generated from field: repeated string favoriteTasks = 18;
   */
  favoriteTasks: string[] = [];

  /**
   * @generated from field: string businessPlan = 19;
   */
  businessPlan = "";

  /**
   * @generated from field: string whyFa = 20;
   */
  whyFa = "";

  /**
   * @generated from field: string friendVisitPlan = 21;
   */
  friendVisitPlan = "";

  /**
   * @generated from field: string referralSource = 22;
   */
  referralSource = "";

  /**
   * @generated from field: map<string, string> trackingParams = 23;
   */
  trackingParams: { [key: string]: string } = {};

  /**
   * @generated from field: string location = 24;
   */
  location = "";

  /**
   * @generated from field: string advisorRef = 25;
   */
  advisorRef = "";

  /**
   * @generated from field: string workProfile = 26;
   */
  workProfile = "";

  /**
   * @generated from field: string taskPrioritization = 28;
   */
  taskPrioritization = "";

  constructor(data?: PartialMessage<AdvisorApplication>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.AdvisorApplication";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "submittedSec", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "lastActivitySec", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "metadata", kind: "message", T: EntityMetadata },
    { no: 6, name: "typeformId", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "firstName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "lastName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "phoneNumber", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "zipCode", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 12, name: "citiesWithExpertise", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "linkedinProfile", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "superpowers", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 15, name: "organizationStrategy", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "hasFlexibility", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 17, name: "willingToRunErrands", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 27, name: "errandSelections", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 18, name: "favoriteTasks", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 19, name: "businessPlan", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 20, name: "whyFa", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 21, name: "friendVisitPlan", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 22, name: "referralSource", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 23, name: "trackingParams", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 24, name: "location", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 25, name: "advisorRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 26, name: "workProfile", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 28, name: "taskPrioritization", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AdvisorApplication {
    return new AdvisorApplication().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AdvisorApplication {
    return new AdvisorApplication().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AdvisorApplication {
    return new AdvisorApplication().fromJsonString(jsonString, options);
  }

  static equals(a: AdvisorApplication | PlainMessage<AdvisorApplication> | undefined, b: AdvisorApplication | PlainMessage<AdvisorApplication> | undefined): boolean {
    return proto3.util.equals(AdvisorApplication, a, b);
  }
}

/**
 * @generated from message protogen.ListAdvisorApplicationsRequest
 */
export class ListAdvisorApplicationsRequest extends Message<ListAdvisorApplicationsRequest> {
  /**
   * @generated from field: repeated string applicationRefs = 1;
   */
  applicationRefs: string[] = [];

  /**
   * @generated from field: protogen.ListAdvisorApplicationsRequest.ApplicationFilter filter = 2;
   */
  filter = ListAdvisorApplicationsRequest_ApplicationFilter.UNKNOWN;

  /**
   * @generated from field: int32 limit = 3;
   */
  limit = 0;

  /**
   * @generated from field: string cursor = 4;
   */
  cursor = "";

  constructor(data?: PartialMessage<ListAdvisorApplicationsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListAdvisorApplicationsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "applicationRefs", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "filter", kind: "enum", T: proto3.getEnumType(ListAdvisorApplicationsRequest_ApplicationFilter) },
    { no: 3, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListAdvisorApplicationsRequest {
    return new ListAdvisorApplicationsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListAdvisorApplicationsRequest {
    return new ListAdvisorApplicationsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListAdvisorApplicationsRequest {
    return new ListAdvisorApplicationsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListAdvisorApplicationsRequest | PlainMessage<ListAdvisorApplicationsRequest> | undefined, b: ListAdvisorApplicationsRequest | PlainMessage<ListAdvisorApplicationsRequest> | undefined): boolean {
    return proto3.util.equals(ListAdvisorApplicationsRequest, a, b);
  }
}

/**
 * @generated from enum protogen.ListAdvisorApplicationsRequest.ApplicationFilter
 */
export enum ListAdvisorApplicationsRequest_ApplicationFilter {
  /**
   * @generated from enum value: UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: NEW = 1;
   */
  NEW = 1,

  /**
   * @generated from enum value: IN_PROGRESS = 2;
   */
  IN_PROGRESS = 2,

  /**
   * @generated from enum value: ALL = 3;
   */
  ALL = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(ListAdvisorApplicationsRequest_ApplicationFilter)
proto3.util.setEnumType(ListAdvisorApplicationsRequest_ApplicationFilter, "protogen.ListAdvisorApplicationsRequest.ApplicationFilter", [
  { no: 0, name: "UNKNOWN" },
  { no: 1, name: "NEW" },
  { no: 2, name: "IN_PROGRESS" },
  { no: 3, name: "ALL" },
]);

/**
 * @generated from message protogen.ListAdvisorApplicationsResponse
 */
export class ListAdvisorApplicationsResponse extends Message<ListAdvisorApplicationsResponse> {
  /**
   * @generated from field: repeated protogen.AdvisorApplication applications = 1;
   */
  applications: AdvisorApplication[] = [];

  /**
   * @generated from field: string nextCursor = 2;
   */
  nextCursor = "";

  constructor(data?: PartialMessage<ListAdvisorApplicationsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListAdvisorApplicationsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "applications", kind: "message", T: AdvisorApplication, repeated: true },
    { no: 2, name: "nextCursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListAdvisorApplicationsResponse {
    return new ListAdvisorApplicationsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListAdvisorApplicationsResponse {
    return new ListAdvisorApplicationsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListAdvisorApplicationsResponse {
    return new ListAdvisorApplicationsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListAdvisorApplicationsResponse | PlainMessage<ListAdvisorApplicationsResponse> | undefined, b: ListAdvisorApplicationsResponse | PlainMessage<ListAdvisorApplicationsResponse> | undefined): boolean {
    return proto3.util.equals(ListAdvisorApplicationsResponse, a, b);
  }
}

/**
 * @generated from message protogen.GetAdvisorApplicationRequest
 */
export class GetAdvisorApplicationRequest extends Message<GetAdvisorApplicationRequest> {
  /**
   * @generated from field: string applicationRef = 1;
   */
  applicationRef = "";

  constructor(data?: PartialMessage<GetAdvisorApplicationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetAdvisorApplicationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "applicationRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetAdvisorApplicationRequest {
    return new GetAdvisorApplicationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetAdvisorApplicationRequest {
    return new GetAdvisorApplicationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetAdvisorApplicationRequest {
    return new GetAdvisorApplicationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetAdvisorApplicationRequest | PlainMessage<GetAdvisorApplicationRequest> | undefined, b: GetAdvisorApplicationRequest | PlainMessage<GetAdvisorApplicationRequest> | undefined): boolean {
    return proto3.util.equals(GetAdvisorApplicationRequest, a, b);
  }
}

/**
 * @generated from message protogen.GetAdvisorApplicationResponse
 */
export class GetAdvisorApplicationResponse extends Message<GetAdvisorApplicationResponse> {
  /**
   * @generated from field: protogen.AdvisorApplication application = 1;
   */
  application?: AdvisorApplication;

  constructor(data?: PartialMessage<GetAdvisorApplicationResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetAdvisorApplicationResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "application", kind: "message", T: AdvisorApplication },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetAdvisorApplicationResponse {
    return new GetAdvisorApplicationResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetAdvisorApplicationResponse {
    return new GetAdvisorApplicationResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetAdvisorApplicationResponse {
    return new GetAdvisorApplicationResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetAdvisorApplicationResponse | PlainMessage<GetAdvisorApplicationResponse> | undefined, b: GetAdvisorApplicationResponse | PlainMessage<GetAdvisorApplicationResponse> | undefined): boolean {
    return proto3.util.equals(GetAdvisorApplicationResponse, a, b);
  }
}

/**
 * @generated from message protogen.UpdateAdvisorApplicationRequest
 */
export class UpdateAdvisorApplicationRequest extends Message<UpdateAdvisorApplicationRequest> {
  /**
   * @generated from field: string ref = 1;
   */
  ref = "";

  /**
   * @generated from field: string updatedStatus = 2;
   */
  updatedStatus = "";

  /**
   * @generated from field: bool shouldUpdateMetadata = 3;
   */
  shouldUpdateMetadata = false;

  /**
   * @generated from field: protogen.EntityMetadata updatedMetadata = 4;
   */
  updatedMetadata?: EntityMetadata;

  constructor(data?: PartialMessage<UpdateAdvisorApplicationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.UpdateAdvisorApplicationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "updatedStatus", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "shouldUpdateMetadata", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "updatedMetadata", kind: "message", T: EntityMetadata },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateAdvisorApplicationRequest {
    return new UpdateAdvisorApplicationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateAdvisorApplicationRequest {
    return new UpdateAdvisorApplicationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateAdvisorApplicationRequest {
    return new UpdateAdvisorApplicationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateAdvisorApplicationRequest | PlainMessage<UpdateAdvisorApplicationRequest> | undefined, b: UpdateAdvisorApplicationRequest | PlainMessage<UpdateAdvisorApplicationRequest> | undefined): boolean {
    return proto3.util.equals(UpdateAdvisorApplicationRequest, a, b);
  }
}

/**
 * @generated from message protogen.UpdateAdvisorApplicationResponse
 */
export class UpdateAdvisorApplicationResponse extends Message<UpdateAdvisorApplicationResponse> {
  /**
   * @generated from field: protogen.AdvisorApplication application = 1;
   */
  application?: AdvisorApplication;

  constructor(data?: PartialMessage<UpdateAdvisorApplicationResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.UpdateAdvisorApplicationResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "application", kind: "message", T: AdvisorApplication },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateAdvisorApplicationResponse {
    return new UpdateAdvisorApplicationResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateAdvisorApplicationResponse {
    return new UpdateAdvisorApplicationResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateAdvisorApplicationResponse {
    return new UpdateAdvisorApplicationResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateAdvisorApplicationResponse | PlainMessage<UpdateAdvisorApplicationResponse> | undefined, b: UpdateAdvisorApplicationResponse | PlainMessage<UpdateAdvisorApplicationResponse> | undefined): boolean {
    return proto3.util.equals(UpdateAdvisorApplicationResponse, a, b);
  }
}

/**
 * @generated from message protogen.SendAdvisorMeetingInvitationRequest
 */
export class SendAdvisorMeetingInvitationRequest extends Message<SendAdvisorMeetingInvitationRequest> {
  /**
   * @generated from field: string applicationRef = 1;
   */
  applicationRef = "";

  /**
   * @generated from field: string screenerRef = 2;
   */
  screenerRef = "";

  constructor(data?: PartialMessage<SendAdvisorMeetingInvitationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.SendAdvisorMeetingInvitationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "applicationRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "screenerRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SendAdvisorMeetingInvitationRequest {
    return new SendAdvisorMeetingInvitationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SendAdvisorMeetingInvitationRequest {
    return new SendAdvisorMeetingInvitationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SendAdvisorMeetingInvitationRequest {
    return new SendAdvisorMeetingInvitationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SendAdvisorMeetingInvitationRequest | PlainMessage<SendAdvisorMeetingInvitationRequest> | undefined, b: SendAdvisorMeetingInvitationRequest | PlainMessage<SendAdvisorMeetingInvitationRequest> | undefined): boolean {
    return proto3.util.equals(SendAdvisorMeetingInvitationRequest, a, b);
  }
}

/**
 * @generated from message protogen.SendAdvisorMeetingInvitationResponse
 */
export class SendAdvisorMeetingInvitationResponse extends Message<SendAdvisorMeetingInvitationResponse> {
  constructor(data?: PartialMessage<SendAdvisorMeetingInvitationResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.SendAdvisorMeetingInvitationResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SendAdvisorMeetingInvitationResponse {
    return new SendAdvisorMeetingInvitationResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SendAdvisorMeetingInvitationResponse {
    return new SendAdvisorMeetingInvitationResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SendAdvisorMeetingInvitationResponse {
    return new SendAdvisorMeetingInvitationResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SendAdvisorMeetingInvitationResponse | PlainMessage<SendAdvisorMeetingInvitationResponse> | undefined, b: SendAdvisorMeetingInvitationResponse | PlainMessage<SendAdvisorMeetingInvitationResponse> | undefined): boolean {
    return proto3.util.equals(SendAdvisorMeetingInvitationResponse, a, b);
  }
}

/**
 * @generated from message protogen.SendAdvisorOfferEmailRequest
 */
export class SendAdvisorOfferEmailRequest extends Message<SendAdvisorOfferEmailRequest> {
  /**
   * @generated from field: string applicationRef = 1;
   */
  applicationRef = "";

  constructor(data?: PartialMessage<SendAdvisorOfferEmailRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.SendAdvisorOfferEmailRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "applicationRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SendAdvisorOfferEmailRequest {
    return new SendAdvisorOfferEmailRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SendAdvisorOfferEmailRequest {
    return new SendAdvisorOfferEmailRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SendAdvisorOfferEmailRequest {
    return new SendAdvisorOfferEmailRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SendAdvisorOfferEmailRequest | PlainMessage<SendAdvisorOfferEmailRequest> | undefined, b: SendAdvisorOfferEmailRequest | PlainMessage<SendAdvisorOfferEmailRequest> | undefined): boolean {
    return proto3.util.equals(SendAdvisorOfferEmailRequest, a, b);
  }
}

/**
 * @generated from message protogen.SendAdvisorOfferEmailResponse
 */
export class SendAdvisorOfferEmailResponse extends Message<SendAdvisorOfferEmailResponse> {
  constructor(data?: PartialMessage<SendAdvisorOfferEmailResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.SendAdvisorOfferEmailResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SendAdvisorOfferEmailResponse {
    return new SendAdvisorOfferEmailResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SendAdvisorOfferEmailResponse {
    return new SendAdvisorOfferEmailResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SendAdvisorOfferEmailResponse {
    return new SendAdvisorOfferEmailResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SendAdvisorOfferEmailResponse | PlainMessage<SendAdvisorOfferEmailResponse> | undefined, b: SendAdvisorOfferEmailResponse | PlainMessage<SendAdvisorOfferEmailResponse> | undefined): boolean {
    return proto3.util.equals(SendAdvisorOfferEmailResponse, a, b);
  }
}

/**
 * @generated from message protogen.SendAdvisorBackgroundCheckEmailRequest
 */
export class SendAdvisorBackgroundCheckEmailRequest extends Message<SendAdvisorBackgroundCheckEmailRequest> {
  /**
   * @generated from field: string applicationRef = 1;
   */
  applicationRef = "";

  constructor(data?: PartialMessage<SendAdvisorBackgroundCheckEmailRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.SendAdvisorBackgroundCheckEmailRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "applicationRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SendAdvisorBackgroundCheckEmailRequest {
    return new SendAdvisorBackgroundCheckEmailRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SendAdvisorBackgroundCheckEmailRequest {
    return new SendAdvisorBackgroundCheckEmailRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SendAdvisorBackgroundCheckEmailRequest {
    return new SendAdvisorBackgroundCheckEmailRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SendAdvisorBackgroundCheckEmailRequest | PlainMessage<SendAdvisorBackgroundCheckEmailRequest> | undefined, b: SendAdvisorBackgroundCheckEmailRequest | PlainMessage<SendAdvisorBackgroundCheckEmailRequest> | undefined): boolean {
    return proto3.util.equals(SendAdvisorBackgroundCheckEmailRequest, a, b);
  }
}

/**
 * @generated from message protogen.SendAdvisorBackgroundCheckEmailResponse
 */
export class SendAdvisorBackgroundCheckEmailResponse extends Message<SendAdvisorBackgroundCheckEmailResponse> {
  constructor(data?: PartialMessage<SendAdvisorBackgroundCheckEmailResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.SendAdvisorBackgroundCheckEmailResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SendAdvisorBackgroundCheckEmailResponse {
    return new SendAdvisorBackgroundCheckEmailResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SendAdvisorBackgroundCheckEmailResponse {
    return new SendAdvisorBackgroundCheckEmailResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SendAdvisorBackgroundCheckEmailResponse {
    return new SendAdvisorBackgroundCheckEmailResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SendAdvisorBackgroundCheckEmailResponse | PlainMessage<SendAdvisorBackgroundCheckEmailResponse> | undefined, b: SendAdvisorBackgroundCheckEmailResponse | PlainMessage<SendAdvisorBackgroundCheckEmailResponse> | undefined): boolean {
    return proto3.util.equals(SendAdvisorBackgroundCheckEmailResponse, a, b);
  }
}

/**
 * @generated from message protogen.SendAdvisorOnboardingEmailRequest
 */
export class SendAdvisorOnboardingEmailRequest extends Message<SendAdvisorOnboardingEmailRequest> {
  /**
   * @generated from field: string applicationRef = 1;
   */
  applicationRef = "";

  constructor(data?: PartialMessage<SendAdvisorOnboardingEmailRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.SendAdvisorOnboardingEmailRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "applicationRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SendAdvisorOnboardingEmailRequest {
    return new SendAdvisorOnboardingEmailRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SendAdvisorOnboardingEmailRequest {
    return new SendAdvisorOnboardingEmailRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SendAdvisorOnboardingEmailRequest {
    return new SendAdvisorOnboardingEmailRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SendAdvisorOnboardingEmailRequest | PlainMessage<SendAdvisorOnboardingEmailRequest> | undefined, b: SendAdvisorOnboardingEmailRequest | PlainMessage<SendAdvisorOnboardingEmailRequest> | undefined): boolean {
    return proto3.util.equals(SendAdvisorOnboardingEmailRequest, a, b);
  }
}

/**
 * @generated from message protogen.SendAdvisorOnboardingEmailResponse
 */
export class SendAdvisorOnboardingEmailResponse extends Message<SendAdvisorOnboardingEmailResponse> {
  constructor(data?: PartialMessage<SendAdvisorOnboardingEmailResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.SendAdvisorOnboardingEmailResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SendAdvisorOnboardingEmailResponse {
    return new SendAdvisorOnboardingEmailResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SendAdvisorOnboardingEmailResponse {
    return new SendAdvisorOnboardingEmailResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SendAdvisorOnboardingEmailResponse {
    return new SendAdvisorOnboardingEmailResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SendAdvisorOnboardingEmailResponse | PlainMessage<SendAdvisorOnboardingEmailResponse> | undefined, b: SendAdvisorOnboardingEmailResponse | PlainMessage<SendAdvisorOnboardingEmailResponse> | undefined): boolean {
    return proto3.util.equals(SendAdvisorOnboardingEmailResponse, a, b);
  }
}

